import request from '@/utils/request'

/**
 * @description: 标书文件相关接口
 */

const purchaseApi = process.env.VUE_APP_PURCHASE_API

// 供应商端接口-------------------------------------------------

/**
 * 查询开评标项目详情
 */
export function getSupplierKpbProjectApi(projectId) {
  return request({
    url: purchaseApi + `/workbench/supplier/kpb/projects/${projectId}/detail`,
    method: 'get'
  })
}

/**
 * 查询投标人信息
 */
export function getSupplierBidderApi(projectId, bidderId) {
  return request(
    {
      url:
        purchaseApi +
        `/workbench/supplier/kpb/projects/${projectId}/bidders/${bidderId}`
    },
    false
  )
}

/**
 * 上传投标文件
 */
export function uploadSupplierBidFileApi(projectId, bidderId, data) {
  return request({
    url:
      purchaseApi +
      `/workbench/supplier/kpb/projects/${projectId}/bidders/${bidderId}/bid-files/upload`,
    method: 'post',
    data
  })
}

// 下载投标文件
export function downloadSupplierFileApi(params) {
  return request({
    url:
      purchaseApi +
      `/workbench/supplier/kpb/projects/${params.projectId}/bidders/${params.bidderId}/bid-files/download`,
    method: 'get',
    params
  })
}

/**
 * 撤回投标文件
 */
export function withdrawSupplierBidFileApi(projectId, bidderId, data) {
  return request({
    url:
      purchaseApi +
      `/workbench/supplier/kpb/projects/${projectId}/bidders/${bidderId}/file-withdraw`,
    method: 'put',
    data
  })
}

/**
 * 查询投标文件的撤回记录列表
 */
export function getSupplierWithdrawHistoryApi(projectId, bidderId) {
  return request({
    url:
      purchaseApi +
      `/workbench/supplier/kpb/projects/${projectId}/bidders/${bidderId}/bid-files/withdraws`,
    method: 'get'
  })
}

// 供应商端下载电子标书附件
export function downloadSupplierKpbBiddingFileApi(params) {
  const fileId = params.fileId
  return request({
    url:
      purchaseApi +
      `/workbench/supplier/kpb/bidding-files/${fileId}/download-bidding-file`,
    method: 'get',
    params
  })
}

// 供应商端预览电子标书附件
export function previewSupplierKpbBiddingFileApi(params) {
  const fileId = params.fileId
  return request({
    url:
      purchaseApi +
      `/workbench/supplier/kpb/bidding-files/${fileId}/preview-bidding-file`,
    method: 'get',
    params
  })
}

// 从签章文件中获取报价
export function getOfferPriceByFileApi(projectId, bidderId, fileId) {
  return request({
    url:
      purchaseApi +
      `/review-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/signature-files/${fileId}/load-offer`,
    method: 'get'
  })
}

// 下载投标单位的报价文件
export function downloadOfferFileApi(params) {
  const { projectId, bidderId } = params
  return request({
    url:
      purchaseApi +
      `/review-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/down-offer-file`,
    method: 'get',
    params
  })
}

// 预览投标单位的报价文件
export function previewOfferFileApi(params) {
  const { projectId, bidderId } = params
  return request({
    url:
      purchaseApi +
      `/review-hall/supplier/kpb/projects/${projectId}/bidders/${bidderId}/preview-offer-file`,
    method: 'get',
    params
  })
}
